import _get from 'lodash/get'
import DetailsActions from './../components/DetailsActions'
import parseAddress from '@/utilities/address/parse'

export const methods = {
  updateRows: function() {
    if (!Array.isArray(this.unitGroupUnits)) {
      return
    }

    this.rows = this.unitGroupUnits.map(entry => {
      const lotNumber = _get(entry.unit, 'lotNumber', '')
      const address = _get(entry.unit, 'address', '')
      const name = parseAddress({ address: address })

      return {
        lotNumber,
        name,
        actions: {
          component: DetailsActions,
          props: {
            item: entry,
            unitGroupUnitID: _get(entry, 'unitGroupUnitID', ''),
            name,
            loadUpdateUnitGroupUnit: (_id, _item) => {
              this.loadUpdateUnitGroupUnit(_id, _item)
            },
            confirmDeleteUnitGroupUnit: (_id, name) => {
              this.confirmDeleteUnitGroupUnit(_id, name)
            }
          }
        }
      }
    })
  }
}
